<template>
    <div class="venue__add">
        <div class="venue__add_header">
            <view-actions
                :title="$t('ebs.venues.add.title.newVenue')"
                :notify-title="$t('ebs.venues.add.title.notifyVenue')"
                :notify-process="$t('ebs.venues.add.title.cancelAdding')"
                :cancel-button-text="$t('ebs.venues.add.title.notifyCancel')"
                :submit-button-active="false"
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: this.$t('ebs.venues.add.name.venues'),
                        to: { name: 'ebs-venue-list' }
                    }
                ]"
                @emit-notify-cancel-submit="venueStopAdd"
            />
        </div>
        <div class="venue__add_main">
            <div class="container">
                <div class="columns change--centered">
                    <div class="column is-6-desktop is-10-tablet is-12-mobile">
                        <venue-edit-form/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import VenueEditForm from '@/components/ebs/venues/edit/VenueEditForm'

export default {
  components: {
    VenueEditForm,
    ViewActions
  },
  name: 'venue-add',
  methods: {
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit('venue-submit')
    },
    //
    venueStopAdd: function () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-venue-list' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/venues/venueaddedit";
</style>
